export default import.meta.ROLLUP_FILE_URL_FBkpMbIVBn0g$LB5A5xhDg